import styled, {css, DefaultTheme} from 'styled-components'
import {Popover} from '@ariakit/react'
import {ExportIndicatorSeverity} from '@/features/exports/hooks/useExportsIndicator'

export const StyledToggleWrapper = styled.div(
    () => css`
        position: relative;
        display: inline-flex;
    `
)

/** Dot colour per severity: pending → orange, ready → green (success), failed → red (danger). */
const severityColor = (palette: DefaultTheme['palette'], severity: ExportIndicatorSeverity): string => {
    switch (severity) {
        case 'pending':
            return palette.orange[500]
        case 'ready':
            return palette.success[500]
        case 'failed':
            return palette.danger[500]
    }
}

export const StyledIndicatorDot = styled.span<{$severity: ExportIndicatorSeverity}>(
    ({theme: {palette}, $severity}) => css`
        position: absolute;
        top: 2px;
        right: 2px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: ${severityColor(palette, $severity)};
        border: 1.5px solid ${palette.neutral.white};
        pointer-events: none;
    `
)

/** "Export ready" announcement popover, anchored above the toggle (replaces the transient toast). */
export const StyledAnnouncementPopover = styled(Popover)(
    ({theme: {spacing, palette, shadows, zIndex}}) => css`
        z-index: ${zIndex.tooltip};
        max-width: 280px;
        padding: ${spacing * 3}px;
        background-color: ${palette.neutral.white};
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        box-shadow: ${shadows.lg};
    `
)

/** Small X button inside the announcement popover that dismisses it. */
export const StyledAnnouncementClose = styled.button(
    () => css`
        display: inline-flex;
        flex-shrink: 0;
        padding: 0;
        border: none;
        background: none;
        cursor: pointer;
        transition: opacity 150ms ease-in-out;

        &:hover {
            opacity: 0.6;
        }
    `
)
